import { useState } from 'react';

export type ToggleState = {
  isOpen: boolean;
  toggle: () => void;
  open: () => void;
  close: () => void;
};

export default function useToggle(initialState = false) {
  const [isOpen, setIsOpen] = useState<boolean>(initialState);
  const toggle = () => setIsOpen(!isOpen);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return { isOpen, toggle, open, close };
}
